export default function ExportCSVButton({onExport}) {
  return (
    <button className="btn btn--link fs-00 lh-x-md" onClick={() => onExport()}>
      ⇣CSV
    </button>
  )
}
